module.exports = __webpack_public_path__ + "img/ribon2.b7089cb3.png";